import React from "react";
import { useQuery } from "data/hooks/useQuery";
import { Ets2_Affidavit } from "data/endpoints";
import { getRouteParams } from "features/shared/helpers/routeParams";
import NoContentWrapper from "features/shared/components/noContentWrapper/NoContentWrapper";
import { Ets2AffidavitFullDTO } from "../dtos/Ets2AffidavitFullDTO";
import { Ets2AffidavitPlaceOfDeliveryDTO } from "../dtos/Ets2AffidavitPlaceOfDeliveryDTO";
import Ets2AffidavitInfoCard from "../components/Ets2AffidavitInfoCard";
import Ets2AffidavitAuthorizedPersonCard from "../components/Ets2AffidavitAuthorizedPersonCard";
import Ets2AffidavitPlaceOfDeliveryCard from "../components/Ets2AffidavitPlaceOfDeliveryCard";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";

interface Props {
  ets2AffidavitId: string;
}

const Ets2AffidavitDetailSection = ({ ets2AffidavitId }: Props) => {
  // translations
  const { i18n } = useTranslation("ets2\\ets2");

  // fetch data
  const { data: affidavit, loadStatus } = useQuery<Ets2AffidavitFullDTO>(
    {
      url: Ets2_Affidavit,
      routeParams: getRouteParams("ets2AffidavitId", ets2AffidavitId),
    },
    {},
    [ets2AffidavitId, i18n.language]
  );

  // render
  return (
    <NoContentWrapper data={affidavit} loadStatus={loadStatus} noContentAsAlert>
      <Ets2AffidavitInfoCard affidavit={affidavit} />
      {affidavit.authorizedPerson && !isEmpty(affidavit.authorizedPerson) && (
        <Ets2AffidavitAuthorizedPersonCard
          person={affidavit.authorizedPerson}
        />
      )}
        <Ets2AffidavitPlaceOfDeliveryCard pods={affidavit.placeOfDeliveries || []} />
    </NoContentWrapper>
  );
};

export default Ets2AffidavitDetailSection;
